"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentScheduleCycleFromEmploymentConditionAndDate = void 0;
var moment_1 = __importDefault(require("moment"));
var getCurrentScheduleCycleFromEmploymentConditionAndDate = function (employmentCondition, date) {
    var _a = employmentCondition.schedule_cycle, year = _a.year, month = _a.month, duration = _a.duration, user_id = employmentCondition.user_id;
    var firstScheduleCycleStart = (0, moment_1.default)([year, month - 1, 1]);
    var monthDiff = (0, moment_1.default)(date).diff(firstScheduleCycleStart, 'month');
    var startCurrentScheduleCycle = (0, moment_1.default)(date)
        .subtract(monthDiff % duration, 'month')
        .startOf('month')
        .format('YYYY-MM-DD');
    var endCurrentScheduleCycle = (0, moment_1.default)(startCurrentScheduleCycle)
        .add(duration - 1, 'month')
        .endOf('month')
        .format('YYYY-MM-DD');
    return {
        user_id: user_id,
        startScheduleCycle: startCurrentScheduleCycle,
        endScheduleCycle: endCurrentScheduleCycle,
    };
};
exports.getCurrentScheduleCycleFromEmploymentConditionAndDate = getCurrentScheduleCycleFromEmploymentConditionAndDate;
